import { Modal, Button } from "antd";
import { completeCarpoolingTripByIdApi, completeTripByIdApi } from "api/trips";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITripsModel } from "models/trips";
import { useState } from "react";

interface IProp {
  open: boolean;
  trip: ITripsModel;
  handleClose: () => void;
}

export default function CompleteTripModal({ open, trip, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadTrips } = useDataLoadingContext();

  const handleCompleteTrip = async () => {
    setLoading(true);
    if (trip.type === "carpooling") {
      const { data, error } = await completeCarpoolingTripByIdApi(trip.id);
      if (data) {
        showSuccess("Carpooling Trip completed successfully");
        loadTrips();
        handleClose();
      } else {
        showError(error!.message);
        // Reload trips to clear stale status (e.g. trip already completed)
        loadTrips();
        handleClose();
      }
    } else {
      const { data, error } = await completeTripByIdApi(trip.id);
      if (data) {
        showSuccess("Trip completed successfully");
        loadTrips();
        handleClose();
      } else {
        showError(error!.message);
        // Reload trips to clear stale status (e.g. trip already completed)
        loadTrips();
        handleClose();
      }
    }
    setLoading(false);
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to complete this trip
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Discard</Button>
          <Button onClick={handleCompleteTrip} loading={loading} type="primary">
            Complete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
